import {
    COLLAPSE_ALL_CRICKET_MARKETS,
    EXPAND_ALL_CRICKET_MARKETS,
    EXPAND_COLLAPSE_CRICKET_MARKET
} from '../constants/actionTypes';

export default (state, action) => {
    switch (action.type) {
        case EXPAND_COLLAPSE_CRICKET_MARKET:
            let newCricketMarketsExpanded = state.cricketMarketsExpanded.slice();
            if (newCricketMarketsExpanded[action.marketIndex] === undefined) {
                throw new Error('Result index is not valid!');
            }
            newCricketMarketsExpanded[action.marketIndex] = !newCricketMarketsExpanded[action.marketIndex];
            return {
                ...state,
                cricketMarketsExpanded: newCricketMarketsExpanded
            };
        case EXPAND_ALL_CRICKET_MARKETS:
            return {
                ...state,
                cricketMarketsExpanded: state.cricketMarketsExpanded.map((mkt)=>true)
            };
        case COLLAPSE_ALL_CRICKET_MARKETS:
            return {
                ...state,
                cricketMarketsExpanded: state.cricketMarketsExpanded.slice().fill(action.type === EXPAND_ALL_CRICKET_MARKETS)
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/reducers/marketsReducer.js